<template>
  <v-app class="grey lighten-3">
    <v-dialog v-model="dialog" width="400">
      <v-card>
        <v-card-title class="title blue accent-3">Timer Dialog</v-card-title>
        <v-card-text>
          <div>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="190px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="updateData.end_date"
                  :rules="endTime"
                  label="Expand Project Ending Time *"
                  v-bind="attrs"
                  prepend-icon="event"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="updateData.end_date"
                :min="new Date().toISOString().substr(0, 10)"
                @change="save"
              ></v-date-picker>
            </v-menu>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="success" flat @click="close">close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" flat @click="updateProjectEndingTime">
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout v-if="isLoaded()">
      <v-flex xs12 sm12 md12>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div class="white--text headline">
                <span>Project Status:</span>
                <span class="black--text headline">
                  {{ this.projectStatus.status_name }}
                </span>
              </div>
              <!-- <div
                class="white--text headline ml-2"
                v-if="
                  this.projectStatus.status_id != 2 &&
                  this.projectStatus.status_id != 3 &&
                  this.projectStatus.status_id != 4
                "
              >
                <span>Payment Status:</span>
                <span class="black--text headline">
                  {{ this.paymentStatus.payment_status_name }}
                </span>
                <span
                  v-if="this.transaction_status_id == 2"
                  class="black--text headline"
                >
                  (pending)
                </span>
                <span
                  v-if="this.transaction_status_id == 3"
                  class="black--text headline"
                >
                  (for modification)
                </span>
                <span
                  v-if="this.transaction_status_id == 4"
                  class="black--text headline"
                >
                  ({{ this.paymentPercentage }}%)
                </span>
              </div> -->
              <v-spacer></v-spacer>
              <div v-if="this.projectStatus.status_id == 4">
                <v-btn small color="primary" class="text-none" @click="modify">
                  Modify Here
                </v-btn>
              </div>
              <!-- <div
                v-if="
                  (this.projectStatus.status_id == 5 ||
                    this.projectStatus.status_id == 8) &&
                  (this.transaction_status_id == 3 ||
                    this.transaction_status_id == null) &&
                  (this.paymentStatus.payment_status_id == 3 ||
                    this.paymentStatus.payment_status_id == 4 ||
                    this.paymentStatus.payment_status_id == 5 ||
                    this.paymentStatus.payment_status_id == 6)
                "
              >
                <v-btn
                  v-if="this.transaction_status_id == 3"
                  small
                  color="primary"
                  class="text-none"
                  @click="modifyPaymentMethod(projectId)"
                >
                  Modify Pay
                </v-btn>
                <v-btn
                  v-else
                  small
                  color="primary"
                  @click="newPaymentMethod(projectId)"
                >
                  Pay
                </v-btn>
              </div>
              <div
                v-if="
                  (this.projectStatus.status_id == 8 ||
                    this.projectStatus.status_id == 7) &&
                  this.transaction_status_id == 4 &&
                  (this.paymentStatus.payment_status_id == 4 ||
                    this.paymentStatus.payment_status_id == 5)
                "
              >
                <v-btn
                  class="no-upercase"
                  small
                  color="primary"
                  @click="payRemainingBalance(projectId)"
                >
                  Pay
                </v-btn>
              </div> -->
              <div v-if="this.projectStatus.status_id == 5">
                <v-btn
                  small
                  color="primary"
                  class="no-upercase"
                  @click="cancelProject(projectId)"
                >
                  Cancel Project
                </v-btn>
              </div>
              <div v-if="this.projectStatus.status_id == 5">
                <v-btn
                  small
                  color="primary"
                  class="no-upercase"
                  @click="goToLive"
                >
                  Go Live
                </v-btn>
              </div>
              <v-btn
                color="blue darken-2"
                v-if="
                  this.projectStatus.status_id == 8 ||
                  this.projectStatus.status_id == 10 ||
                  this.projectStatus.status_id == 12 ||
                  this.projectStatus.status_id == 13 ||
                  this.projectStatus.status_id == 11
                "
                small
                dark
                class="text-none"
                @click="getResponse(projectId)"
              >
                Response
              </v-btn>
              <div v-if="this.projectStatus.status_id == 10">
                <v-btn
                  small
                  class="no-upercase"
                  color="primary"
                  @click="updateProjectToCompleteStatus"
                >
                  Click Complete
                </v-btn>
                <v-btn
                  small
                  class="no-upercase"
                  color="primary"
                  @click="expandDate"
                >
                  Expand Date
                </v-btn>
              </div>
              <v-btn color="blue darken-2" small dark @click="back">
                Back
                <!-- <v-icon dark left>arrow_backward</v-icon> -->
              </v-btn>
            </v-card-title>
            <v-card-text>
              <template>
                <v-data-table
                  :items="indexData.project"
                  class="elevation-1"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <tr>
                      <td>Project ID</td>
                      <td class="text-xs-left">{{ props.item.id }}</td>
                    </tr>
                    <tr>
                      <td>Project Name</td>
                      <td class="text-xs-left">{{ props.item.name }}</td>
                    </tr>
                    <tr>
                      <td>Project Type</td>
                      <td class="text-xs-left">
                        {{ props.item.project_type_name }}
                      </td>
                    </tr>
                    <tr>
                      <td>Project Created By</td>
                      <td class="text-xs-left">{{ props.item.created_by }}</td>
                    </tr>
                    <tr>
                      <td>Project Created At</td>
                      <td class="text-xs-left">{{ props.item.created_at }}</td>
                    </tr>
                    <tr>
                      <td>Project Description</td>
                      <td class="text-xs-left">{{ props.item.details }}</td>
                    </tr>
                    <tr>
                      <td>Project Language</td>
                      <td class="text-xs-left">
                        {{ getProjectLanguage(props.item.project_language) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Estimated Starting Time</td>
                      <td class="text-xs-left">{{ props.item.begin_date }}</td>
                    </tr>
                    <tr>
                      <td>Estimated Ending Time</td>
                      <td class="text-xs-left">{{ props.item.end_date }}</td>
                    </tr>
                    <tr v-if="props.item.project_type_id == 2">
                      <td>Visual Radius</td>
                      <td class="text-xs-left">
                        {{ props.item.visual_radius_km }} Km
                      </td>
                    </tr>
                    <tr v-if="props.item.project_type_id == 2">
                      <td>Acceptable Radius</td>
                      <td class="text-xs-left">
                        {{ props.item.acceptance_radius_m }} Meter
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Project live at</td>
                      <td class="text-xs-left">{{ props.item.live_at }}</td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Project live by</td>
                      <td class="text-xs-left">{{ props.item.live_by }}</td>
                    </tr>
                    <tr>
                      <td>Total Budget(Tk)</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_amount }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Total Budget(coins)</td>
                      <td class="text-xs-left">
                        {{ props.item.total_budget_coins }}
                      </td>
                    </tr>
                    <tr>
                      <td>Per Survey Cost(Coins)</td>
                      <td class="text-xs-left">
                        {{ props.item.per_survey_cost }}
                      </td>
                    </tr>
                    <tr>
                      <td>Per Survey Cost(Tk)</td>
                      <td class="text-xs-left">
                        {{ getTakaFromCoins(props.item.per_survey_cost) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Required Total Response</td>
                      <td class="text-xs-left">
                        {{ props.item.number_of_response }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Remaining Balance</td>
                      <td class="text-xs-left">
                        {{ props.item.budget_remains }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Remaining Balance(Tk)</td>
                      <td class="text-xs-left">
                        {{ getTakaFromCoins(props.item.budget_remains) }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Holding Balance</td>
                      <td class="text-xs-left">
                        {{ props.item.holding_budget }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Processing Response</td>
                      <td class="text-xs-left">
                        {{ props.item.total_processing_res }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Pending Response</td>
                      <td class="text-xs-left">
                        {{ props.item.total_pending_res }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Accepted Response</td>
                      <td class="text-xs-left">
                        {{ props.item.total_accepted_res }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Modified Response</td>
                      <td class="text-xs-left">
                        {{ props.item.total_modified_res }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Rejected Response</td>
                      <td class="text-xs-left">
                        {{ props.item.total_rejected_res }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Canceled Response</td>
                      <td class="text-xs-left">
                        {{ props.item.total_canceled_res }}
                      </td>
                    </tr>
                    <tr v-if="props.item.project_status_id >= 8">
                      <td>Project Completed</td>
                      <td
                        class="text-xs-left"
                        v-if="props.item.completion_percentage == null"
                      >
                        0%
                      </td>
                      <td class="text-xs-left" v-else>
                        {{ props.item.completion_percentage }}%
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </template>

              <!-- start location -->
              <v-card-title v-if="this.projectTypeId == 2" class="project">
                <div class="white--text headline">
                  <span>Project's Locations</span>
                </div>
              </v-card-title>
              <v-card-text v-if="this.projectTypeId == 2">
                <v-data-table
                  :headers="headers"
                  :items="indexData.res_location"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.division_name }}</td>
                    <td>{{ props.item.district_name }}</td>
                    <td>{{ props.item.upazila_name }}</td>
                    <td>{{ props.item.area }}</td>
                    <td>{{ props.item.zip_code }}</td>
                    <td>{{ props.item.latitude }}</td>
                    <td>{{ props.item.longitude }}</td>
                    <td>{{ props.item.address }}</td>
                  </template>
                </v-data-table>
              </v-card-text>
              <!-- end location -->
            </v-card-text>
            <assigned-agent-group-to-project
              v-if="indexData.project[0].project_type_id === 3"
              :project_id="indexData.project[0].id"
            ></assigned-agent-group-to-project>
            <assigned-teams-to-project
              v-if="indexData.project[0].dasher_category_id === 2"
              :project_id="indexData.project[0].id"
            ></assigned-teams-to-project>

            <v-card v-if="checkData">
              <v-card-title class="project">
                <div>
                  <span class="headline white--text">Pre Survey Question</span>
                </div>
              </v-card-title>
              <v-card-text>
                <div>
                  <span class="font-weight-bold">
                    Note:Here star mark (
                    <span class="red--text">*</span>
                    ) is required.
                  </span>
                  <br />
                  <div
                    v-for="(pre_ques, index) in indexData.pre_survey_question"
                    v-bind:key="index"
                  >
                    <!-- start pre survey question part -->
                    <div>
                      <span>Pre_Q{{ index + 1 }}.</span>
                      <span
                        v-if="
                          indexData.project[0].project_language == 1 ||
                          indexData.project[0].project_language == 3
                        "
                      >
                        <span class="font-weight-bold">
                          Question Title English:
                        </span>
                        &nbsp;&nbsp;&nbsp;{{ pre_ques.question_title_en }}
                        <span
                          class="red--text headline"
                          v-if="pre_ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          indexData.project[0].project_language == 2 ||
                          indexData.project[0].project_language == 3
                        "
                      >
                        &nbsp;&nbsp;&nbsp;
                        <span class="font-weight-bold">
                          Question Title Bangla:
                        </span>
                        &nbsp;&nbsp;&nbsp;{{ pre_ques.question_title_bn }}
                        <br />
                        <span
                          class="red--text headline"
                          v-if="pre_ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <!-- option and multiple image section -->
                      <div
                        v-if="
                          pre_ques.ui_category_id == 1 ||
                          pre_ques.ui_category_id == 2 ||
                          pre_ques.ui_category_id == 4 ||
                          pre_ques.ui_category_id == 14
                        "
                      >
                        <div v-if="pre_ques.ui_category_id == 14">
                          <span
                            v-for="(option, i) in pre_ques.pre_image_options"
                            :key="i"
                          >
                            <v-img
                              height="150"
                              width="200"
                              :src="
                                indexData.pre_ques_option_base_url + option.url
                              "
                            ></v-img>
                            <a
                              :href="
                                indexData.pre_ques_option_base_url + option.url
                              "
                              target="_blank"
                            >
                              download
                            </a>
                            <div class="mt-3"></div>
                          </span>
                        </div>
                        <div v-else>
                          <div
                            v-if="
                              pre_ques.pre_options &&
                              (indexData.project[0].project_language == 1 ||
                                indexData.project[0].project_language == 3)
                            "
                          >
                            <span class="font-weight-bold">
                              Option English:
                            </span>
                            <br />
                            <span
                              v-for="(option, i) in pre_ques.pre_options"
                              :key="i"
                            >
                              <v-icon small>radio_button_unchecked</v-icon>
                              {{ option.title }}
                              <br />
                            </span>
                          </div>
                          <div
                            v-if="
                              pre_ques.option_bangla != null &&
                              (indexData.project[0].project_language == 2 ||
                                indexData.project[0].project_language == 3)
                            "
                          >
                            <br />
                            <span class="font-weight-bold">Option Bangla:</span>
                            <br />
                            <span
                              v-for="(option, i) in pre_ques.pre_bangla_options"
                              :key="i"
                            >
                              <v-icon small>radio_button_unchecked</v-icon>
                              {{ option.title }}
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div>
                        <span
                          v-if="
                            pre_ques.instruction != null &&
                            (indexData.project[0].project_language == 1 ||
                              indexData.project[0].project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Instruction English:
                          </span>
                          <div
                            v-html="
                              decode_info(pre_ques.pre_instruction.instruction)
                            "
                          ></div>
                        </span>
                        <span
                          v-if="
                            pre_ques.instruction_bangla != null &&
                            (indexData.project[0].project_language == 2 ||
                              indexData.project[0].project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Instruction Bangla:
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(
                                pre_ques.pre_instruction_bangla
                                  .instruction_bangla
                              )
                            "
                          ></div>
                        </span>
                        <span
                          v-if="
                            pre_ques.description != null &&
                            (indexData.project[0].project_language == 1 ||
                              indexData.project[0].project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Description English:
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(pre_ques.pre_description.description)
                            "
                          ></div>
                        </span>
                        <span
                          v-if="
                            pre_ques.description_bangla != null &&
                            (indexData.project[0].project_language == 1 ||
                              indexData.project[0].project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Description Bangla:
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(
                                pre_ques.pre_description_bangla
                                  .description_bangla
                              )
                            "
                          ></div>
                        </span>
                      </div>
                    </div>
                    <div>
                      <pre-survey-question-logic
                        :pre_question_logic="pre_ques.pre_question_logic"
                        :operators="indexData.operators"
                      />
                    </div>
                    <!-- end pre survey question part -->
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card>
              <v-card-title class="project">
                <div><span class="headline white--text">Question</span></div>
              </v-card-title>
              <v-card-text>
                <div>
                  <span class="font-weight-bold">
                    Note:Here star mark (
                    <span class="red--text">*</span>
                    ) is required.
                  </span>
                  <br />
                  <div
                    v-for="(ques, index) in indexData.question"
                    v-bind:key="index"
                  >
                    <!--start question part -->
                    <div>
                      <span v-if="ques.question == ''" class="red--text">
                        {{ q_validate }}
                        <br />
                      </span>
                      <span>{{ index + 1 }}.</span>
                      <span
                        v-if="
                          indexData.project[0].project_language == 1 ||
                          indexData.project[0].project_language == 3
                        "
                      >
                        <span class="font-weight-bold">
                          Question Title English:
                        </span>
                        &nbsp;&nbsp;&nbsp;{{ ques.question }}
                        <span
                          class="red--text headline"
                          v-if="ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <span
                        v-if="
                          indexData.project[0].project_language == 2 ||
                          indexData.project[0].project_language == 3
                        "
                      >
                        &nbsp;&nbsp;&nbsp;
                        <span class="font-weight-bold">
                          Question Title Bangla:
                        </span>
                        &nbsp;&nbsp;&nbsp;{{ ques.question_bangla }}
                        <br />
                        <span
                          class="red--text headline"
                          v-if="ques.required_optional == 1"
                        >
                          *
                        </span>
                      </span>
                      <br />
                      <div v-if="ques.ui_category_id == 15">
                        <span v-if="ques.first_name == '1'">
                          First Name: _________
                        </span>
                        <span v-if="ques.middle_name == '1'">
                          <br />
                          Middle Name: _________
                        </span>
                        <span v-if="ques.last_name == '1'">
                          <br />
                          Last Name: _________
                        </span>
                        <span v-if="ques.phone == '1'">
                          <br />
                          <v-icon small>call</v-icon>
                          Phone: _________
                        </span>
                        <span v-if="ques.email == '1'">
                          <br />
                          email: _________
                        </span>
                        <span v-if="ques.address == '1'">
                          <br />
                          <v-icon small>home</v-icon>
                          <span class="font-weight-bold">Address:</span>
                          <br />
                          Country: _________
                          <br />
                          Division: _________
                          <br />
                          District : _________
                          <br />
                          Area: _________
                          <br />
                          Road No: _________
                          <br />
                          House No: _________
                        </span>
                      </div>
                      <!-- option and multiple image section -->
                      <div
                        v-if="
                          ques.ui_category_id == 1 ||
                          ques.ui_category_id == 2 ||
                          ques.ui_category_id == 4 ||
                          ques.ui_category_id == 14
                        "
                      >
                        <div
                          v-if="ques.ui_category_id == 14 && ques.image_options"
                        >
                          <span
                            v-for="(option, i) in ques.image_options"
                            :key="i"
                          >
                            <v-img
                              height="150"
                              width="200"
                              :src="indexData.image_op + option.url"
                            ></v-img>
                            <a
                              :href="indexData.image_op + option.url"
                              target="_blank"
                            >
                              download
                            </a>
                            <div class="mt-3"></div>
                          </span>
                        </div>
                        <div v-else>
                          <div
                            v-if="
                              ques.options &&
                              (indexData.project[0].project_language == 1 ||
                                indexData.project[0].project_language == 3)
                            "
                          >
                            <span class="font-weight-bold">
                              Option English:
                            </span>
                            <br />
                            <span v-for="(option, i) in ques.options" :key="i">
                              <v-icon small>radio_button_unchecked</v-icon>
                              {{ option.title }}
                              <br />
                            </span>
                          </div>
                          <div
                            v-if="
                              ques.bangla_options != null &&
                              (indexData.project[0].project_language == 2 ||
                                indexData.project[0].project_language == 3)
                            "
                          >
                            <br />
                            <span class="font-weight-bold">Option Bangla:</span>
                            <br />
                            <span
                              v-for="(option, i) in ques.bangla_options"
                              :key="i"
                            >
                              <v-icon small>radio_button_unchecked</v-icon>
                              {{ option.title }}
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- instruction and description -->
                      <div>
                        <span
                          v-if="
                            ques.instruction != null &&
                            (indexData.project[0].project_language == 1 ||
                              indexData.project[0].project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Instruction English:
                          </span>
                          <div
                            v-html="decode_info(ques.instruction.instruction)"
                          ></div>
                        </span>
                        <span
                          v-if="
                            ques.instruction_bangla != null &&
                            (indexData.project[0].project_language == 2 ||
                              indexData.project[0].project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Instruction Bangla:
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(
                                ques.instruction_bangla.instruction_bangla
                              )
                            "
                          ></div>
                        </span>
                        <span
                          v-if="
                            ques.description != null &&
                            (indexData.project[0].project_language == 1 ||
                              indexData.project[0].project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Description English:
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="decode_info(ques.description.description)"
                          ></div>
                        </span>
                        <span
                          v-if="
                            ques.description_bangla != null &&
                            (indexData.project[0].project_language == 1 ||
                              indexData.project[0].project_language == 3)
                          "
                        >
                          <span class="font-weight-bold">
                            Description Bangla:
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <div
                            v-html="
                              decode_info(
                                ques.description_bangla.description_bangla
                              )
                            "
                          ></div>
                        </span>
                      </div>
                      <!-- date time question -->
                      <div v-if="ques.ui_category_id == 12">
                        <span v-if="ques.date_time.date_time != null">
                          <span class="font-weight-bold">Date:</span>
                          {{ ques.date_time.date_time }}
                        </span>
                      </div>
                      <!-- multiple answer -->
                      <div v-if="ques.ui_category_id == 2">
                        <span class="font-weight-bold">Multiple ans:</span>
                        <v-icon small class="mr-1">
                          check_box_outline_blank
                        </v-icon>
                        <span v-if="ques.multiple_answer == 1">yes</span>
                        <span v-else>no</span>
                      </div>
                      <!-- range slider star rating -->
                      <div
                        v-if="
                          ques.ui_category_id == 6 ||
                          ques.ui_category_id == 7 ||
                          ques.ui_category_id == 8
                        "
                      >
                        <span
                          v-if="
                            ques.option_val.min_value != null &&
                            ques.option_val.max_value != null
                          "
                        >
                          <span class="font-weight-bold">Min value:</span>
                          {{ ques.option_val.min_value }}
                          <br />
                          <span class="font-weight-bold">Max value:</span>
                          {{ ques.option_val.max_value }}
                        </span>
                        <span v-if="ques.option_val.interval != null">
                          <br />
                          <span class="font-weight-bold">Interval:</span>
                          {{ ques.option_val.interval }}
                        </span>
                      </div>
                      <div v-if="ques.has_logic">
                        <question-logic
                          :question_logic="
                            JSON.parse(ques.question_logic.question_logic)
                          "
                          :questions="indexData.question"
                          :counter_index="index"
                        />
                      </div>
                    </div>
                    <br />
                    <!-- end question part -->
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <!-- <v-btn @click="save">submit</v-btn> -->
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";
  import router from "../../../router";
  import { ROOT_URL } from "@/api/connectingUrls";
  import {
    QuestionLogic,
    PreSurveyQuestionLogic,
    AssignedAgentGroupToProject,
    AssignedTeamsToProject,
  } from "@/components/index";
  import axios from "axios";

  export default {
    components: {
      QuestionLogic,
      PreSurveyQuestionLogic,
      AssignedAgentGroupToProject,
      AssignedTeamsToProject,
    },
    data: () => ({
      apiUrl: "client-view",
      menu: false,
      editedIndex: -1,
      dialog: false,
      projectId: "",
      transaction_status_id: "",
      paymentPercentage: "",
      projectStatus: {
        status_name: null,
        status_id: null,
      },
      paymentStatus: {
        payment_status_name: null,
        payment_status_id: null,
      },
      projectTypeId: null,
      headers: [
        { text: "Id", align: "left", value: "id" },
        { text: "Division", align: "left", value: "division_name" },
        { text: "District", align: "left", value: "district_name" },
        { text: "Upazila", align: "left", value: "upazila_name" },
        { text: "Area", sortable: false, value: "area" },
        { text: "Zip Code", sortable: false, value: "zip_code" },
        { text: "Latitude", sortable: false, value: "latitude" },
        { text: "Longitude", sortable: false, value: "longtude" },
        { text: "Address", value: "address" },
      ],
      updateData: {
        project_id: null,
        end_date: null,
      },
      endTime: [(v) => !!v || "Enter project ending time"],
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      checkData() {
        if (this.indexData.project) {
          if (this.indexData.project[0].has_pre_survey) {
            return 1;
          } else {
            return 0;
          }
        }
        return 0;
      },
    },

    watch: {
      menu(val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.projectId = localStorage.getItem("project_details_by_id");
        this.$store.dispatch("getProjectDetails", [
          this.projectId,
          "client-view",
        ]);
      },
      isLoaded() {
        if (typeof this.indexData.project != "undefined") {
          this.projectStatus.status_id =
            this.indexData.project[0].project_status.id;
          this.projectStatus.status_name =
            this.indexData.project[0].project_status.name;
          this.projectTypeId = this.indexData.project[0].project_type_id;
          this.paymentStatus.payment_status_name =
            this.indexData.project[0].payment_status_name;
          this.paymentStatus.payment_status_id =
            this.indexData.project[0].payment_status_id;
          this.transaction_status_id =
            this.indexData.project[0].transaction_status_id;
          this.paymentPercentage = Math.round(
            (this.indexData.project[0].paid_amount * 100) /
              this.indexData.project[0].grand_total
          );
          localStorage.setItem("projectId", this.indexData.project[0].id);
          return true;
        } else {
          return false;
        }
      },
      decode_info(value) {
        if (value != undefined) {
          return JSON.parse(value);
        }
        return "";
      },
      getProjectLanguage(project_language) {
        if (project_language == 1) {
          return "English";
        } else if (project_language == 2) {
          return "Bangla";
        } else {
          return "English & Bangla both";
        }
      },
      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },
      getTakaFromCoins(coins) {
        return coins / 10;
      },
      save(date) {
        this.$refs.menu.save(date);
        this.menu = false;
      },
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.budget = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      modify() {
        // this.$store.dispatch('editProject',[ this.projectId, 'edit-project'])
        localStorage.setItem("project_id_modify", this.projectId);
        localStorage.setItem(
          "project_status_id",
          this.indexData.project[0].project_status_id
        );
        this.$store.dispatch("indexDataAndRout", [
          "project-info",
          this.projectId,
          "/edit-project",
        ]);
      },
      //go to payment option
      newPaymentMethod(project_id) {
        this.$store.dispatch("paymentPage", ["payment", project_id]);
      },
      modifyPaymentMethod() {
        alert("It is not completed!");
      },
      payRemainingBalance(project_id) {
        // this.$store.dispatch("remainingPaymentPage", ["payment", project_id]);
        this.$store.dispatch("paymentPage", ["payment", project_id]);
      },
      //go to cancel status
      cancelProject(projectId) {
        var popUpMsg = confirm(
          "Are you sure? If you want to cancel, Project will go to cancel status!"
        );
        if (popUpMsg) {
          this.$store.dispatch("cancelProjectBeforePay", [projectId, "cancel"]);
        }
        this.close();
      },
      goToLive() {
        router.push("success-pay");
      },

      expandDate() {
        this.updateData.end_date = this.indexData.project[0].end_date;
        this.updateData.project_id = this.indexData.project[0].id;
        this.dialog = true;
      },

      async updateProjectEndingTime() {
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
            return axios
              .post(`${ROOT_URL}/${"update-ending-time"}`, this.updateData, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                // console.log(response);
                if (response.data.statusCode == 200) {
                  this.initialize();
                  this.close();
                }
              });
          }
        } catch (error) {
          // console.log(error);
        }
      },

      async updateProjectToCompleteStatus() {
        var popUpMsg = confirm(
          "Are you sure to change project status to complete!"
        );
        if (popUpMsg) {
          try {
            const token = window.localStorage.getItem("datadash_token"),
              projectId = this.projectId;
            if (token != null) {
              return axios
                .get(`${ROOT_URL}/${"update-status"}/${projectId}`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                })
                .then((response) => {
                  // console.log(response);
                  if (response.data.statusCode == 200) {
                    this.initialize();
                  }
                });
            }
          } catch (error) {
            // console.log(error);
          }
        }
      },
      back() {
        // router.push("/project-list");
        router.push("/all-project");
      },
      getResponse(projectId) {
        // console.log(projectId)
        this.$store.dispatch("getProjectResponse", [projectId, "task"]);
      },
    },
  };
</script>

<style scoped>
  .icon {
    background: #ff2e2e;
    color: aliceblue;
    cursor: pointer;
    border-radius: none;
    margin: 10px;
  }
  .delete {
    color: #3f51b5;
    cursor: pointer;
  }
  span {
    width: 20px;
    cursor: pointer;
  }
  .no-upercase {
    text-transform: unset !important;
  }
  .text_color {
    color: white;
  }
  .project {
    background: #ff2e2e;
  }
</style>
